import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import normalizeWidgetInput from 'src/common/normalizeWidgetInput';
import widgetDefinition from './ESGIBMFlashsystems.widget';
import { RenderFn } from 'src/types/widgets';
import ESGIBMFlashsystems from './components/ESGIBMFlashsystems';

const render: RenderFn = async function (instanceId, langCode, origin, cb) {
  const { element, locale, messages } = await normalizeWidgetInput(
    instanceId,
    langCode,
    widgetDefinition,
  );
  if (!element || !locale) {
    return;
  }
  ReactDOM.render(
    <IntlProvider locale={locale} messages={messages} defaultLocale="en">
      <ESGIBMFlashsystems />
    </IntlProvider>,
    element,
    () => cb(element),
  );
};

export default render;
